import React from "react";

export function SaveIcon() {
  return <i className="fas fa-floppy-disk"></i>;
}
